<!-- prettier-ignore -->

<div class="register-standalone-container">
    <swiper #swiperRegisterStandalone [pagination]="false" [simulateTouch]="false" [allowTouchMove]="false" class="register-swiper-standalone">

        @if(techOptions){
            <ng-template swiperSlide >
                <div id="calendar" class="register-component">
                    <cicerone-register-step-calendar class="component"
                        [registerStandalone]="true"
                        (calendarDataEmitter)="handleReceivedData($event, 'calendar')"
                    />
                    <register-action-buttons-standalone 
                        [isFirstSlide]="isFirstSlide()" 
                        [isLastSlide]="isLastSlide()"
                        (actionButtonsEmiter)="swiperNavigate($event)" 
                    />
                </div>
            </ng-template>
        }

        @if(techOptions?.travelerType){
            <ng-template swiperSlide>
                <div id="travelerType" class="register-component">
                    <cicerone-register-step-traveler-type class="component" 
                        (travelerTypeEmitter)="handleReceivedData($event, 'travelerType')"
                        [travellerTypes]="techOptions.travelerType"
                    />
                    <register-action-buttons-standalone 
                        [isFirstSlide]="isFirstSlide()" 
                        (actionButtonsEmiter)="swiperNavigate($event)" 
                    />                
                </div>
            </ng-template>
        }
    
        @if(techOptions?.categories){
            <ng-template swiperSlide>
                <div id="interestType" class="register-component">
                    <cicerone-register-step-interest-type class="component"
                        (interestTypeEmitter)="handleReceivedData($event, 'interestType')"
                        [isRegisterStandaloneApp]="true" 
                        [categories]="techOptions.categories" 
                        [subCategories]="techOptions?.subCategories"
                    />
                    <register-action-buttons-standalone 
                        [isFirstSlide]="isFirstSlide()" 
                        (actionButtonsEmiter)="swiperNavigate($event)" 
                    /> 
                </div>

            </ng-template>
        }
    
        @if(techOptions?.registerBefore?.[this.translate.currentLang]?.length > 0){
            <ng-template swiperSlide>
                <div id="registerBefore" class="register-component">
                    <cicerone-registers-after-before class="component"
                        (registerBeforeEmitter)="handleReceivedData($event, 'registerBefore')"
                        [countries]="techOptions?.countries" 
                        [provinces]="techOptions?.provinces" 
                        [registerData]="techOptions?.registerBefore" 
                        [isBefore]="true"
                    />
                    <register-action-buttons-standalone 
                        [isFirstSlide]="isFirstSlide()" 
                        (actionButtonsEmiter)="swiperNavigate($event)" 
                    /> 
                </div>
            </ng-template>
        }

        @if(techOptions?.registerAfter?.[this.translate.currentLang]?.length > 0){
            <ng-template swiperSlide>
                <div id="registerAfter" class="register-component">
                    <cicerone-registers-after-before class="component"
                        (registerAfterEmitter)="handleReceivedData($event, 'registerAfter')"
                        [countries]="techOptions?.countries" 
                        [provinces]="techOptions?.provinces" 
                        [registerData]="techOptions?.registerAfter" 
                        [isAfterStandalone]="true"
                    />
                    <register-action-buttons-standalone 
                        [isFirstSlide]="isFirstSlide()" 
                        (actionButtonsEmiter)="swiperNavigate($event)" 
                    /> 
                </div>
            </ng-template>
        }

        @if(techOptions){
            <ng-template swiperSlide >
                <div id="userForm" class="register-component">
                    <cicerone-register-step-user-data class="component" (formActionEmiter)="swiperNavigate($event)" />
                </div>
            </ng-template>
        }
    
    </swiper>
    
</div>

